// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__uUn3M","loaderOuter":"PageOverlayLoader_loaderOuter__eryLW"};